import TextInput from "../../../components/molecules/inputs/TextInput";
import TextAreaInput from "../../../components/molecules/inputs/TextAreaInput";
import MobileInput from "../../../components/molecules/inputs/MobileInput";
import { useState, useEffect } from "react";
import api from "../../../Api";
import axios from "axios";

interface CommonDataResponse {
  success: boolean;
  message: string;
  commonData: CommonDataItem[];
}

interface CommonDataItem {
  _id: string;
  siteName: string;
  address: string;
  discription: string;
  email: string;
  primaryMobileNumberContryCode: string;
  primaryMobileNumber: string;
  secondaryMobileNumberContryCode: string;
  secondaryMobileNumber: string;
  noreplayEmail: string;
  password: string;
  receivingEmail: string;
  __v: number;
}

export default function CommonData() {
  const [siteName, setSiteName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [secondaryMobileNumber, setSecondaryMobileNumber] =
    useState<string>("");
  const [
    secondaryMobileNumberCountryCode,
    setSecondaryMobileNumberCountryCode,
  ] = useState<string>("");
  const [countryCode, setCountryCode] = useState<string>("");

  const [noReplayEmail, setNoReplayEmail] = useState<string>("");
  const [emailPassword, setEmailPassword] = useState<string>("");
  const [recevingEmail, setRecevingEmail] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  //Placeholders
  const [siteNamePlaceHolder, setSiteNamePlaceHolder] =
    useState<string>("Enter website name");
  const [emailPlaceHolder, setEmailPlaceHolder] = useState<string>(
    "Enter primary email"
  );
  const [addressPlaceHolder, setAddressPlaceHolder] = useState<string>(
    "Enter the address of the company"
  );
  const [descriptionPlaceHolder, setDescriptionPlaceHolder] = useState<string>(
    "Enter the description of the company"
  );

  const [mobileNumberPlaceHolder, setMobileNumberPlaceHolder] =
    useState<string>("enter the mobile number");
  const [
    secondaryMobileNumberPlaceHolder,
    setSecondaryMobileNumberPlaceHolder,
  ] = useState<string>("enter the secondary mobile number");

  const [noReplayEmailPlaceHolder, setNoReplayEmailPlaceHolder] =
    useState<string>("Enter noreplay email");

  const [emailPasswordPlaceHolder, setEmailPasswordPlaceHolder] =
    useState<string>("Enter noreplay email password");

  const [recevingEmailPlaceHolder, setRecevingEmailPlaceHolder] =
    useState<string>("Enter receiving email");

  const handleSiteName = (value: string) => {
    setSiteName(value);
  };

  const handleEmail = (value: string) => {
    setEmail(value);
  };

  const handleAddress = (value: string) => {
    setAddress(value);
  };

  const handleDescription = (value: string) => {
    setDescription(value);
  };

  const handleMobileNumberInputChange = (value: string) => {
    setMobileNumber(value);
  };

  const handleSecondaryMobileNumberInputChange = (value: string) => {
    setSecondaryMobileNumber(value);
  };

  const handleCountryCodeInputChange = (countryCode: string) => {
    setCountryCode(countryCode);
  };

  const handleSecondaryCountryCodeInputChange = (countryCode: string) => {
    setSecondaryMobileNumberCountryCode(countryCode);
  };

  const handleNoReplayEmail = (value: string) => {
    setNoReplayEmail(value);
  };

  const noreplayEmailPassword = (value: string) => {
    setEmailPassword(value);
  };

  const handdleRecevingEmail = (value: string) => {
    setRecevingEmail(value);
  };

  // Function to fetch common data
  const fetchCommonData = async (): Promise<void> => {
    try {
      const response = await axios.get<CommonDataResponse>(api.commonData, {
        headers: {
          api_key: api.key,
          authentication: api.authantication,
        },
      });

      const commonData = response.data.commonData[0];

      if (commonData) {
        setSiteNamePlaceHolder(commonData.siteName || "");
        setEmailPlaceHolder(commonData.email || "");
        setAddressPlaceHolder(commonData.address || "");
        setDescriptionPlaceHolder(commonData.discription || "");
        setMobileNumberPlaceHolder(commonData.primaryMobileNumber || "");
        setSecondaryMobileNumberPlaceHolder(
          commonData.secondaryMobileNumber || ""
        );
        setCountryCode(commonData.primaryMobileNumberContryCode || "");
        setSecondaryMobileNumberCountryCode(
          commonData.secondaryMobileNumberContryCode || ""
        );
        setNoReplayEmailPlaceHolder(commonData.noreplayEmail || "");
        setEmailPasswordPlaceHolder(`${commonData.password && "******"}`);
        setRecevingEmailPlaceHolder(commonData.receivingEmail || "");
      }
    } catch (error) {
      console.error("Error fetching common data:", error);
    }
  };

  // Fetch comon data
  useEffect(() => {
    fetchCommonData();
  }, []);

  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      // Dynamically construct payload with only non-empty values
      const payload: { [key: string]: string } = {};

      if (siteName) payload.siteName = siteName;
      if (email) payload.email = email;
      if (address) payload.address = address;
      if (description) payload.discription = description;
      if (mobileNumber) payload.primaryMobileNumber = `${mobileNumber}`;
      if (secondaryMobileNumber)
        payload.secondaryMobileNumber = secondaryMobileNumber;
      if (noReplayEmail) payload.noreplayEmail = noReplayEmail;
      if (emailPassword) payload.password = emailPassword;
      if (recevingEmail) payload.receivingEmail = recevingEmail;

      // Ensure payload is not empty
      if (Object.keys(payload).length === 0) {
        alert("No values to update.");
        return;
      }

      const response = await axios.put(api.commonData, payload, {
        headers: {
          api_key: api.key,
          authentication: api.authantication,
        },
      });

      if (response.data.success) {
        console.log("Data updated successfully:", response.data.message);
        setIsLoading(false);
      } else {
        console.error("Error in response:", response.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error updating common data:", error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="flex items-center space-x-4 pb-8">
        <div className="w-[20%]">
          <h1 className="font-primary text-title">Site Details</h1>
        </div>

        <div className="w-[30%] space-y-4 py-4">
          <TextInput
            Name="Site Name"
            Placeholder={siteNamePlaceHolder}
            Value={siteName}
            onChange={handleSiteName}
          />
          <TextAreaInput
            Name="Address"
            Placeholder={addressPlaceHolder}
            Value={address}
            onChange={handleAddress}
          />
          <TextAreaInput
            Name="Discription"
            Placeholder={descriptionPlaceHolder}
            Value={description}
            onChange={handleDescription}
          />
        </div>
      </div>

      <hr />

      <div className="flex items-center space-x-4 pb-8">
        <div className="w-[20%]">
          <h1 className="font-primary text-title">Contact Details</h1>
        </div>

        <div className="w-[30%] space-y-4 py-4">
          <TextInput
            Name="Email"
            Placeholder={emailPlaceHolder}
            Value={email}
            Capitalize={false}
            onChange={handleEmail}
          />
          <MobileInput
            Name="Primary Mobile Number"
            Placeholder={mobileNumberPlaceHolder}
            Value={mobileNumber}
            CountryCode={countryCode}
            onChange={handleMobileNumberInputChange}
            onClick={handleCountryCodeInputChange}
          />
          <MobileInput
            Name="Secondary Mobile Number"
            Placeholder={secondaryMobileNumberPlaceHolder}
            Value={secondaryMobileNumber}
            CountryCode={secondaryMobileNumberCountryCode}
            onChange={handleSecondaryMobileNumberInputChange}
            onClick={handleSecondaryCountryCodeInputChange}
          />
        </div>
      </div>

      <hr />

      <div className="flex items-center space-x-4 pb-8">
        <div className="w-[20%]">
          <h1 className="font-primary text-title">Email Configaration</h1>
        </div>

        <div className="w-[30%] space-y-4 py-4">
          <TextInput
            Name="Noreplay Email"
            Placeholder={noReplayEmailPlaceHolder}
            Value={noReplayEmail}
            Capitalize={false}
            onChange={handleNoReplayEmail}
          />
          <TextInput
            Name="Password"
            Placeholder={emailPasswordPlaceHolder}
            Type="password"
            Value={emailPassword}
            onChange={noreplayEmailPassword}
          />
          <TextInput
            Name="Receiving Email"
            Placeholder={recevingEmailPlaceHolder}
            Value={recevingEmail}
            Capitalize={false}
            onChange={handdleRecevingEmail}
          />
        </div>
      </div>

      <div className="flex justify-end items-center w-[820px]">
        <button
          onClick={handleUpdate}
          className={`duration-300 text-white p-2 px-4 rounded duration-300 ${
            siteName ||
            noReplayEmail ||
            email ||
            address ||
            description ||
            mobileNumber ||
            secondaryMobileNumber ||
            emailPassword ||
            recevingEmail
              ? "bg-primary"
              : "bg-black/[.30]"
          }`}
        >
          {isLoading ? "Updateing..." : "Update"}
        </button>
      </div>
    </div>
  );
}
